import { IUserInfoCreate } from '../interfaces/userInfoCreate';
import { PataviumRole } from '../enums/role.enum.model';
import { IShadowUserCreate } from '../interfaces/shadowUserCreate';
import { AttachType } from '../enums/attachType';
import { ContractPermission } from '../enums/contractPermission';
import { BrandType } from '../enums/brandType';
import { CustomerVisibilityType } from '../enums/customerVisibility';
import { ShadowUserCreate } from './shadowUserCreate';

export class UserInfoCreate implements IUserInfoCreate {
    anagraphicUser: IShadowUserCreate = new ShadowUserCreate();
    customerVisibility: CustomerVisibilityType;
    canExportContract: boolean;
    canDoExportSemplice: boolean;
    canDoExportGas: boolean;
    canDoExportEe: boolean;
    canMoveCustomers: boolean;
    canStopContracts: boolean;
    contractDelayTolerance: number;
    email: string;
    firstName: string;
    idGroup: number;
    idRole: PataviumRole;
    lastName: string;
    needVerificationCall: boolean;
    optionalContractAttaches: AttachType[] = [];
    password: string;
    permissionContractsType: ContractPermission = ContractPermission.None;
    permitBrands: BrandType[];
    teleselling: boolean;
    username: string;
    canDoAdesioneADistanza: boolean;
    canHandleStopForErrors: boolean;
    canDoChiamataBenvenuto: boolean;
    canDoPortaUnAmico: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/classes/userInfoCreate.ts